// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hJh0HDy1NFJLXtywpuJz[data-is-current-position="true"] {
  position: sticky;
  top: 0px;
  bottom: 0px;
  z-index: 10;
  background-color: #1c1c1e;
}
.hJh0HDy1NFJLXtywpuJz[data-is-current-position="true"]::before {
  content: '';
  position: absolute;
  top: 1px;
  left: 1px;
  right: 1px;
  bottom: 1px;
  border-radius: 5px;
  padding: 2px;
  background: linear-gradient(to bottom, #fff439, #c59029, #fffda4, #f9c419, #fff86b, #b16c04, #fbce35);
  -webkit-mask: linear-gradient(white, white) content-box, linear-gradient(white, white);
  -webkit-mask-composite: xor;
  mask-composite: exclude;
  pointer-events: none;
}
.hJh0HDy1NFJLXtywpuJz[data-is-current-position="false"] {
  position: relative;
  top: auto;
  bottom: auto;
  z-index: auto;
  background-color: transparent;
}
.hJh0HDy1NFJLXtywpuJz[data-is-current-position="false"]::before {
  content: none;
}
.eG88T2yUDVHIeM5jDgPF {
  padding-left: 10px;
  font-size: 21px;
  font-weight: 400;
  line-height: 1.1;
  letter-spacing: 0.17px;
  max-width: 94px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: var(--font-family-primary, inherit);
}
.JIkvTxCcHHlU8rJ9dQ2k {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.jAJHzaSx6u_DmSdKbssW {
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: var(--font-family-secondary);
  font-size: 22px;
  font-weight: 800;
  line-height: 1;
  letter-spacing: 0.17px;
  padding-right: 2px;
  color: var(--campaign-color-text-white);
}
.xdB8ZR0GMNhHRnttuO2A {
  font-size: 22px;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  .eG88T2yUDVHIeM5jDgPF {
    font-size: 14px;
  }
  .jAJHzaSx6u_DmSdKbssW {
    font-size: 15px;
  }
  .xdB8ZR0GMNhHRnttuO2A {
    font-size: 15px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/campaigns/components/variants/tournaments/tabs/RankingTab/TablePlayerRow/TablePlayerRow.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,QAAQ;EACR,WAAW;EACX,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,qGAAqG;EACrG,sFAAsF;EACtF,2BAA2B;EAC3B,uBAAuB;EACvB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,aAAa;EACb,6BAA6B;AAC/B;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gDAAgD;AAClD;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yCAAyC;EACzC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,uCAAuC;AACzC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":[".tablePlayerRow[data-is-current-position=\"true\"] {\n  position: sticky;\n  top: 0px;\n  bottom: 0px;\n  z-index: 10;\n  background-color: #1c1c1e;\n}\n.tablePlayerRow[data-is-current-position=\"true\"]::before {\n  content: '';\n  position: absolute;\n  top: 1px;\n  left: 1px;\n  right: 1px;\n  bottom: 1px;\n  border-radius: 5px;\n  padding: 2px;\n  background: linear-gradient(to bottom, #fff439, #c59029, #fffda4, #f9c419, #fff86b, #b16c04, #fbce35);\n  -webkit-mask: linear-gradient(white, white) content-box, linear-gradient(white, white);\n  -webkit-mask-composite: xor;\n  mask-composite: exclude;\n  pointer-events: none;\n}\n.tablePlayerRow[data-is-current-position=\"false\"] {\n  position: relative;\n  top: auto;\n  bottom: auto;\n  z-index: auto;\n  background-color: transparent;\n}\n.tablePlayerRow[data-is-current-position=\"false\"]::before {\n  content: none;\n}\n.playerName {\n  padding-left: 10px;\n  font-size: 21px;\n  font-weight: 400;\n  line-height: 1.1;\n  letter-spacing: 0.17px;\n  max-width: 94px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-family: var(--font-family-primary, inherit);\n}\n.tableCell {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.scoreCell {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-family: var(--font-family-secondary);\n  font-size: 22px;\n  font-weight: 800;\n  line-height: 1;\n  letter-spacing: 0.17px;\n  padding-right: 2px;\n  color: var(--campaign-color-text-white);\n}\n.scoreRow {\n  font-size: 22px;\n  line-height: 1.2;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n@media (--campaign-mobile) {\n  .playerName {\n    font-size: 14px;\n  }\n  .scoreCell {\n    font-size: 15px;\n  }\n  .scoreRow {\n    font-size: 15px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tablePlayerRow": `hJh0HDy1NFJLXtywpuJz`,
	"playerName": `eG88T2yUDVHIeM5jDgPF`,
	"tableCell": `JIkvTxCcHHlU8rJ9dQ2k`,
	"scoreCell": `jAJHzaSx6u_DmSdKbssW`,
	"scoreRow": `xdB8ZR0GMNhHRnttuO2A`
};
export default ___CSS_LOADER_EXPORT___;
